import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalificacionComponent } from './formulario/formulario.component';
import { CalificacionBoletaComponent } from "./boleta-kardex/lista.component";
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'control-escolar/calificacion',
    children: [
       { path: 'nuevo', component: CalificacionComponent }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'control-escolar/boleta-kardex',
    children: [
      { path: 'lista', component: CalificacionBoletaComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CalificacionRoutingModule { }

